
export const enum GrantType {
    PASSWORD = "PASSWORD",
    AUTH_PROVIDER_CODE = "AUTH_PROVIDER_CODE",
    REFRESH_TOKEN = "REFRESH_TOKEN",

}


